import {useEffect, useState} from "react";
import {IYear} from "../../utils/interfaces/IYear";
import {IPeriod} from "../../utils/interfaces/IPeriod";
import PeriodRow from "./PeriodRow";
import {motion} from 'framer-motion';


interface PeriodsListProps {
    obj: IYear,
}

function PeriodsList({obj: initialObj}: PeriodsListProps) {
    const [obj, setObj] = useState<IYear>(initialObj)

    const mapped_objs = obj?.periods.map((obj: IPeriod, index) => (
        <motion.div
            key={obj.month}
            initial={{x: '150%'}}
            animate={{x: '0%'}}
            transition={{duration: 0.2, delay: index * 0.03}}
        >
            <PeriodRow obj={obj}/>
        </motion.div>

    ));

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])


    return (
        <div className='ml-8'>
            {mapped_objs}
        </div>
    )
}

export default PeriodsList;